export default {"src":"/_next/static/media/shareResultsIcon.22d702f4.svg","height":22,"width":20};